import { render } from "./MatchExpressions.vue?vue&type=template&id=4f417ac0&scoped=true"
import script from "./MatchExpressions.vue?vue&type=script&lang=js"
export * from "./MatchExpressions.vue?vue&type=script&lang=js"

import "./MatchExpressions.vue?vue&type=style&index=0&id=4f417ac0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f417ac0"]])

export default __exports__